(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["soso-card-preview"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('soso-card-preview'))customElements.define('soso-card-preview',class extends HTMLElement{
  connectedCallback(){
    if(this.abort||!this.dataset.gifSrc)return;
    this.card=this.closest('.product-card,.soso-cart-recommendation');this.gif=this.querySelector('.card-animation');this.trigger=this.querySelector('.soso-card-preview-trigger');
    if(!this.card||!this.gif||!this.trigger)return;
    this.abort=new AbortController();const signal=this.abort.signal;
    this.card.setAttribute('data-preview-enabled','');this.hovered=false;this.loaded=false;this.failed=false;this.suppressClick=false;
    this.gif.addEventListener('load',()=>{this.loaded=this.gif.naturalWidth>0;this.update();},{signal});
    this.gif.addEventListener('error',()=>{this.loaded=false;this.failed=true;this.update();},{signal});
    this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.update();}},{signal});
    this.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){this.hovered=false;this.update();}},{signal});
    this.card.addEventListener('pointerdown',e=>{
      this.suppressClick=false;this.touchClick=null;
      if(e.pointerType==='mouse'||e.isPrimary===false)return;
      this.contact={id:e.pointerId,x:e.clientX,y:e.clientY,moved:false,wasSelected:this.constructor.selected===this};
      this.select();
    },{signal,passive:true});
    window.addEventListener('pointermove',e=>{
      if(this.contact&&e.pointerId===this.contact.id&&Math.hypot(e.clientX-this.contact.x,e.clientY-this.contact.y)>12)this.contact.moved=true;
    },{signal,passive:true});
    window.addEventListener('pointerup',e=>{
      if(this.contact&&e.pointerId===this.contact.id)this.finishTouch(this.contact.moved||Math.hypot(e.clientX-this.contact.x,e.clientY-this.contact.y)>12);
    },{signal,passive:true});
    window.addEventListener('pointercancel',e=>{if(this.contact&&e.pointerId===this.contact.id)this.finishTouch(true);},{signal,passive:true});
    // Cancel only a completed drag, never a normal title or size-link tap.
    this.card.addEventListener('click',e=>{
      if(e.detail!==0&&this.suppressClick){e.preventDefault();e.stopPropagation();this.suppressClick=false;}
    },{signal,capture:true});
    this.trigger.addEventListener('click',e=>{
      const touch=this.touchClick;this.touchClick=null;
      // Mouse, keyboard and modified clicks retain native link behavior.
      if(e.detail===0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
      if(touch&&Date.now()-touch.time<1000&&!touch.wasSelected){
        e.preventDefault();this.select();
      }
    },{signal});
    this.card.addEventListener('keydown',e=>{if(e.key==='Escape'){this.reset();}},{signal});
    window.addEventListener('blur',()=>this.reset(),{signal});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)this.reset();},{signal});
  }
  select(){
    const previous=this.constructor.selected;this.constructor.selected=this;
    if(previous&&previous!==this){previous.hovered=false;previous.update();}
    this.update();
  }
  update(){
    const active=Boolean(this.hovered||this.constructor.selected===this);
    if(active&&!this.gif.hasAttribute('src')&&!this.failed)this.gif.src=this.dataset.gifSrc;
    const playing=active&&this.loaded;
    this.toggleAttribute('data-playing',playing);this.gif.hidden=!playing;
  }
  finishTouch(suppress){if(this.contact)this.touchClick={wasSelected:this.contact.wasSelected,time:Date.now()};this.contact=null;this.suppressClick=suppress;this.update();}
  reset(){this.hovered=false;if(this.constructor.selected===this)this.constructor.selected=null;this.finishTouch(Boolean(this.contact));}
  disconnectedCallback(){
    if(this.constructor.selected===this)this.constructor.selected=null;
    this.contact=null;this.abort?.abort();this.abort=null;
    this.card?.removeAttribute('data-preview-enabled');this.removeAttribute('data-playing');
    if(this.gif){this.gif.hidden=true;this.gif.removeAttribute('src');}
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soso-nav"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('soso-shop-menu'))customElements.define('soso-shop-menu',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;
    this.ready=true;
    this.closeOutside=(event)=>{if(!this.contains(event.target))this.close();};
    document.addEventListener('click',this.closeOutside);
    this.addEventListener('keydown',(event)=>{
      if(event.key!=='Escape')return;
      const expanded=event.target.closest('details[open]');
      if(!expanded)return;
      event.preventDefault();event.stopPropagation();expanded.open=false;expanded.querySelector('summary')?.focus();
    });
  }
  close(){this.querySelectorAll('details[open]').forEach(details=>details.open=false);}
  disconnectedCallback(){document.removeEventListener('click',this.closeOutside);this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soso-pattern-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{
 if(!event.target.matches('[data-variant-select]'))return;
 const selected=event.target.selectedOptions[0];
 const title=selected.dataset.variantTitle;
 if(!title)return;
 event.target.closest('.product-info').querySelectorAll('[data-pattern-link]').forEach(link=>{
  let variants;try{variants=JSON.parse(link.dataset.variants)}catch{return}
  const match=variants.find(variant=>variant.title.split(' / ').at(-1)===title.split(' / ').at(-1));
  const url=new URL(link.dataset.productUrl,location.origin);
  if(match)url.searchParams.set('variant',match.id);
  link.href=url.pathname+url.search;
 });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soso-quantity-picker"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('soso-quantity-picker'))customElements.define('soso-quantity-picker',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;
    this.ready=true;
    this.input=this.querySelector('input');
    this.output=this.querySelector('output');
    this.onClick=event=>{
      const button=event.target.closest('[data-quantity-step]');
      if(!button||button.disabled)return;
      this.update(Number(this.input.value)+Number(button.dataset.quantityStep)*Number(this.dataset.step));
    };
    this.addEventListener('click',this.onClick);
    this.onVariant=event=>{
      if(this.hasAttribute('data-cart')||!event.target.matches('[data-variant-select]')||event.target.form!==this.closest('form'))return;
      const option=event.target.selectedOptions[0];
      this.dataset.min=option.dataset.quantityMin||'1';
      this.dataset.step=option.dataset.quantityStep||'1';
      if(option.dataset.quantityMax==='')delete this.dataset.max;
      else this.dataset.max=option.dataset.quantityMax;
      this.update(Number(this.input.value));
    };
    document.addEventListener('change',this.onVariant);
  }
  disconnectedCallback(){document.removeEventListener('change',this.onVariant);this.removeEventListener('click',this.onClick);this.ready=false;}
  update(value){
    const min=Number(this.dataset.min),step=Number(this.dataset.step)||1;
    const max=this.hasAttribute('data-max')?Math.max(min,Number(this.dataset.max)):Infinity;
    value=Math.max(min,Math.min(max,min+Math.round((value-min)/step)*step));
    this.input.value=String(value);
    this.output.textContent=String(value);
    this.querySelector('[data-quantity-step="-1"]').disabled=value<=min;
    this.querySelector('[data-quantity-step="1"]').disabled=value+step>max;
    this.input.dispatchEvent(new Event('change',{bubbles:true}));
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soso-size-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{const picker=event.target.closest('[data-size-picker]');if(!picker)return;const select=picker.querySelector('[data-variant-select]');if(event.target.matches('input[type=radio]')){select.value=event.target.value;select.dispatchEvent(new Event('change',{bubbles:true}));}if(event.target===select){const label=picker.querySelector('[data-selected-size]');if(label)label.textContent=select.selectedOptions[0].dataset.size;}});
document.addEventListener('click',event=>{const picker=event.target.closest('[data-size-picker]');if(!picker)return;const dialog=picker.querySelector('dialog');if(!dialog)return;if(event.target.closest('[data-open-chart]'))dialog.showModal();if(event.target.closest('[data-close-chart]'))dialog.close();if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}const unit=event.target.closest('[data-size-unit]');if(unit){picker.querySelectorAll('[data-size-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b===unit)));picker.querySelectorAll('[data-chart-unit]').forEach(table=>table.hidden=table.dataset.chartUnit!==unit.dataset.sizeUnit);}});
  } catch(e) { console.error(e); }
})();

})();
